import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import * as Icon from 'react-feather';
import { Col, Row } from 'reactstrap';
import Flatpickr from 'react-flatpickr';
import 'rc-slider/assets/index.css';

const ItemServiceTimes = ({
  serviceTimes,
  ItemAvailableAt,
  orderConditionAvilableAt,
  onAddClick,
}) => {
  const [serviceTimesLocalState, setServiceTimesLocalState] = useState([[]]);

  const availableAt = orderConditionAvilableAt || [];
  const getDateByDayOfWeek = (dayOfWeek, time) => {
    const now = new Date();
    const today = (now.getDay() + 6) % 7; // Adjust for Monday as the first day
    const daysUntilTargetDay = (dayOfWeek + 7 - today) % 7;

    let targetDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + daysUntilTargetDay,
    );

    const daysSinceTargetDay = (today + 7 - dayOfWeek) % 7;
    const endOfWeek = getEndOfWeek(now);

    if (daysSinceTargetDay !== daysUntilTargetDay || targetDate > endOfWeek) {
      // Return the nearest date within the current week
      targetDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + (dayOfWeek - today),
      );
    }

    return targetDate;
  };

  // Function to get the end of the current week
  const getEndOfWeek = (date) => {
    const endOfWeek = new Date(date);
    endOfWeek.setDate(date.getDate() + ((6 - date.getDay() + 1) % 7)); // Adjust for Monday as the first day
    return endOfWeek;
  };

  useEffect(() => {
    onAddClick(serviceTimesLocalState);
  }, [serviceTimesLocalState]);

  const getDayOfWeek = (date) => {
    const dateObject = new Date(date);
    const dayIndex = (dateObject.getDay() + 6) % 7;
    return dayIndex;
  };

  const days = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];
  useEffect(() => {
    const updatedServiceTimesThatExpired = Object.values(availableAt);

    const serviceTimeHours = days.map((day, index) =>
      updatedServiceTimesThatExpired?.filter(
        (serviceTime) => getDayOfWeek(serviceTime.startAt) === index,
      ),
    );
    setServiceTimesLocalState(serviceTimeHours);
  }, [serviceTimes]);

  const removeTimeSpan = (dayIndex, serviceTimeIndex) => {
    setServiceTimesLocalState((prevState) => {
      const newServiceTimes = [...prevState];
      newServiceTimes[dayIndex] = newServiceTimes[dayIndex].filter(
        (serviceTime, index) => index !== serviceTimeIndex,
      );
      return newServiceTimes;
    });
  };

  const addNewTimeSpan = (dayIndex) => {
    const defaultStartTime = getDateByDayOfWeek(dayIndex);
    defaultStartTime.setHours(9, 0, 0, 0);
    const newDefaultStartTimeObject = new Date(defaultStartTime);
    let defaultStartTimeString = newDefaultStartTimeObject.toISOString();

    const defaultEndTime = getDateByDayOfWeek(dayIndex);
    const newDefaultEndTime = defaultEndTime.setHours(
      defaultEndTime.getHours() + 23,
    );
    const newDefaultEndTimeObject = new Date(newDefaultEndTime);
    let defaultEndTimeString = newDefaultEndTimeObject.toISOString();

    setServiceTimesLocalState((prevState) => {
      const newServiceTimes = [
        ...prevState.slice(0, dayIndex),
        [
          ...prevState[dayIndex],
          {
            startAt: defaultStartTimeString,
            endAt: defaultEndTimeString,
          },
        ],
        ...prevState.slice(dayIndex + 1),
      ];
      return newServiceTimes;
    });
  };

  const addTimeFromDate = (date1, date2) => {
    const hours = date1.getHours();
    const minutes = date1.getMinutes();
    const seconds = date1.getSeconds();

    let returnObj = new Date(date2);

    returnObj.setHours(hours);
    returnObj.setMinutes(minutes);
    returnObj.setSeconds(seconds);

    return returnObj;
  };

  const handleStartTimeChange = (dayIndex, serviceTimeIndex, date) => {
    const dateToDateObject = new Date(date);

    const defaultStartTime = getDateByDayOfWeek(dayIndex);
    const newStartTime = addTimeFromDate(dateToDateObject, defaultStartTime);
    const newStartTimeObject = new Date(newStartTime);
    let startTimeString = newStartTimeObject.toISOString();
    let newServiceTime;
    setServiceTimesLocalState((prevState) => {
      newServiceTime = prevState[dayIndex];
      const newServiceTimes = [
        ...prevState.slice(0, dayIndex),
        [
          ...newServiceTime.slice(0, serviceTimeIndex),
          { ...newServiceTime[serviceTimeIndex], startAt: startTimeString },
          ...newServiceTime.slice(serviceTimeIndex + 1),
        ],
        ...prevState.slice(dayIndex + 1),
      ];
      return newServiceTimes;
    });
    handleEndTimeChange(
      dayIndex,
      serviceTimeIndex,
      newServiceTime[serviceTimeIndex]?.endAt,
      startTimeString,
    );
  };

  const handleEndTimeChange = (
    dayIndex,
    serviceTimeIndex,
    date,
    serviceTimeStart,
  ) => {
    const dateToDateObject = new Date(date);

    const defaultStartTime = new Date(serviceTimeStart);

    const endTime = addTimeFromDate(dateToDateObject, defaultStartTime);

    const serviceTimeStartObj = new Date(serviceTimeStart);
    const serviceObjTime = serviceTimeStartObj.getTime();

    let newEndTimeObject = new Date(endTime);

    const endTimeWithoutDate = newEndTimeObject.getTime();

    if (endTimeWithoutDate <= serviceObjTime) {
      endTime.setDate(defaultStartTime.getDate() + 1);
      newEndTimeObject = new Date(endTime);
    }

    const endTimeString = newEndTimeObject.toISOString();

    setServiceTimesLocalState((prevState) => {
      const newServiceTime = prevState[dayIndex];
      const newServiceTimes = [
        ...prevState.slice(0, dayIndex),
        [
          ...newServiceTime.slice(0, serviceTimeIndex),
          { ...newServiceTime[serviceTimeIndex], endAt: endTimeString },
          ...newServiceTime.slice(serviceTimeIndex + 1),
        ],
        ...prevState.slice(dayIndex + 1),
      ];
      return newServiceTimes;
    });
  };

  return (
    <>
      {serviceTimesLocalState?.map((day, dayIndex) => {
        return (
          <>
            <Row
              key={dayIndex}
              className="d-flex justify-content-center align-items-center my-1 match-height"
            >
              <Col className="d-flex align-items-center mb-50 mb-sm-0 " xs={12}>
                {/* ${opening_hours?.length === 0 ? 'text-muted text-decoration-line-through' : 'dark'}} */}
                <span
                  style={{ width: '80px' }}
                  className={`mr-2 font-medium-1 text-bold-500 text-truncate`}
                >
                  <FormattedMessage id={days[dayIndex]} />
                </span>

                <Icon.PlusSquare
                  id="add-timespan"
                  className="primary"
                  size={22}
                  onClick={() => addNewTimeSpan(dayIndex)}
                />
              </Col>
              <Col xs={12}>
                {day?.map((serviceTime, serviceTimeIndex) => {
                  return (
                    <div
                      key={serviceTimeIndex}
                      className="d-flex justify-content-between align-items-center my-50"
                    >
                      <Flatpickr
                        className="form-control bg-white text-center px-50"
                        value={serviceTime?.startAt}
                        options={{
                          enableTime: true,
                          noCalendar: true,
                          dateFormat: 'H:i',
                          time_24hr: true,
                        }}
                        onChange={(date) => {
                          handleStartTimeChange(
                            dayIndex,
                            serviceTimeIndex,
                            date,
                          );
                        }}
                      />

                      <span className="mx-2 mx-sm-1">
                        <FormattedMessage id="to" />
                      </span>

                      <Flatpickr
                        className="form-control bg-white text-center px-50"
                        value={serviceTime.endAt}
                        options={{
                          enableTime: true,
                          noCalendar: true,
                          dateFormat: 'H:i',
                          time_24hr: true,
                          defaultHour: '',
                          defaultMinute: '',
                          allowInput: false,
                          // minTime: wh.start
                        }}
                        onChange={(date) =>
                          handleEndTimeChange(
                            dayIndex,
                            serviceTimeIndex,
                            date,
                            serviceTime.startAt,
                          )
                        }
                      />
                      <span className="ml-1">
                        <Icon.MinusSquare
                          id="remove-timespan"
                          size={20}
                          className="danger"
                          onClick={() =>
                            removeTimeSpan(dayIndex, serviceTimeIndex)
                          }
                        />
                      </span>
                    </div>
                  );
                })}
              </Col>
            </Row>
            <hr />
          </>
        );
      })}
    </>
  );
};

const mapStateToProps = (state) => ({
  serviceTimes: state.store.serviceTimes,
  ItemAvailableAt: state.modals.editItemModalDataAvailableAt,
  storeId: state.store.store?.id,
});

export default connect(mapStateToProps)(ItemServiceTimes);
